import { Collapse, Stack } from '@mui/material';
import React from 'react';
import { CreatePlanLivePreview } from '../../../plans/CreatePlanPage/create-plan-page-components/CreatePlanLivePreview/CreatePlanLivePreview';
import { useCreateInvoiceContext } from '../create-invoice-page-contexts/create-invoice-context/create-invoice-context';
import type { InvoiceCreationStep } from '../create-invoice-page-contexts/create-invoice-context/create-invoice-context-types/invoice-creation-step';
import { INVOICE_CREATION_STEPS } from '../create-invoice-page-contexts/create-invoice-context/create-invoice-context-types/invoice-creation-step';
import { CreateInvoicePageTabs } from './CreateInvoicePageTabs/CreateInvoicePageTabs';
import { CreateInvoiceSettings } from './CreateInvoiceSettings';

const INVOICE_CREATION_STEPS_CONTENT: Record<InvoiceCreationStep, React.ReactElement> = {
  [INVOICE_CREATION_STEPS.settings]: <CreateInvoiceSettings/>,
  [INVOICE_CREATION_STEPS.content]: <CreateInvoicePageTabs/>,
};

export const CreateInvoicePageContent: React.FC = () => {
  const {
    invoiceCreationStepper: { currentStep },
    planPreview: { open, hide }, 
  } = useCreateInvoiceContext();

  return (
    <div className="flex h-full w-full overflow-y-hidden bg-[#F6F9FA]">
      <Stack
        height="100%"
        padding="16px 24px"
        flex={1}
      >
        {INVOICE_CREATION_STEPS_CONTENT[currentStep]}
      </Stack>

      <Collapse
        in={open}
        orientation="horizontal"
        sx={{
          height: '100%',
        }}
      >
        <CreatePlanLivePreview
          title="Invoice Preview"
          onHide={hide}
        />
      </Collapse>
    </div>
  );
};